import { Autocomplete } from 'src/components/Autocomplete';
import { Stack } from 'src/components/Stack';
import { TextField } from 'src/components/TextField';
import { useSession } from 'src/contexts/SessionContext';

interface CustomProfileFieldFilterProps {
  value: any;
  setValue: (value: any, close?: boolean) => void;
  field: string;
  label: string;
  valueOnly?: boolean;
}

export const CustomProfileFieldFilter = ({
  value,
  setValue,
  valueOnly = false,
}: CustomProfileFieldFilterProps): React.ReactNode => {
  const { session } = useSession();

  const customFields = (session?.trainerProfileFields || []).map((field) => ({
    id: field,
    name: field,
  }));

  if (valueOnly) {
    return <>{value?.field ? `${value.field}: ${value.value}` : ''}</>;
  }

  return (
    <Stack spacing={2}>
      <Autocomplete
        size="small"
        value={customFields.find((f) => f.id === value?.field) || null}
        onChange={(_, newValue) => {
          setValue(
            newValue
              ? {
                  field: newValue?.id || '',
                  value: value?.value || '',
                }
              : null
          );
        }}
        options={customFields}
        getOptionLabel={(option) => option.name}
        renderInput={(params) => (
          <TextField {...params} label="Field" size="small" />
        )}
      />
      <TextField
        size="small"
        label="Value"
        value={value?.value || ''}
        onChange={(e) => {
          setValue({
            field: value?.field || '',
            value: e.target.value,
          });
        }}
      />
    </Stack>
  );
};
